import { Router } from '@angular/router';
import { CommonsUtils } from 'app/commons/CommonsUtils';
var OtherInsuranceComponent = /** @class */ (function () {
    function OtherInsuranceComponent(router) {
        this.router = router;
        this.seguros = CommonsUtils.otherProducs();
        this.subtitulo = '';
        this.footer = 'Soluciones adaptadas a tus necesidades.';
    }
    Object.defineProperty(OtherInsuranceComponent.prototype, "items", {
        get: function () {
            return (this.seguros || []).slice(0, 3);
        },
        enumerable: true,
        configurable: true
    });
    OtherInsuranceComponent.prototype.irA = function (link) {
        this.router.navigate([link]);
    };
    OtherInsuranceComponent.prototype.abrirEnlace = function (link) {
        if (link) {
            window.open(link, '_blank', 'noopener');
        }
    };
    OtherInsuranceComponent.prototype.iconForInsurance = function (s, idx) {
        var base = 'resources/assets/images/main-page/';
        var map = {
            plane: 'onlygal-asistencia-viaje.svg',
            travel: 'onlygal-asistencia-viaje.svg',
            viaje: 'onlygal-asistencia-viaje.svg',
            asistencia: 'onlygal-asistencia-viaje.svg',
            home: 'onlygal-compraventa-asegurada.svg',
            compraventa: 'onlygal-compraventa-asegurada.svg',
            vivienda: 'onlygal-compraventa-asegurada.svg',
            alquiler: 'onlygal-compraventa-asegurada.svg',
            shieldcheck: 'onlygal-abogado-365.svg',
            legal: 'onlygal-abogado-365.svg',
            abogado: 'onlygal-abogado-365.svg',
            ocupacion: 'onlygal-abogado-365.svg',
            car: 'car.svg',
            coche: 'car.svg'
        };
        var defaults = ['onlygal-asistencia-viaje.svg', 'onlygal-compraventa-asegurada.svg', 'onlygal-abogado-365.svg'];
        var key = ((s && s.icon) || '').toLowerCase().trim();
        for (var _i = 0, _a = Object.keys(map); _i < _a.length; _i++) {
            var k = _a[_i];
            if (key && key.indexOf(k) !== -1) {
                return base + map[k];
            }
        }
        return base + (defaults[idx % defaults.length] || 'bag-2.svg');
    };
    return OtherInsuranceComponent;
}());
export { OtherInsuranceComponent };
